module.exports = __webpack_public_path__ + "img/man-fish.e29b6f29.jpg";